module.exports = __webpack_public_path__ + "img/new-booking.6bfe1977.svg";